import { useState, useEffect } from 'react';

import Login from "./components/auth_control/Login";
import TwoFactorAuth from "./components/auth_control/TwoFactorAuth";
import AuthenticatedUser from "./components/auth_control/AuthenticatedUser";
import checkIsTokenAlive from './services/checkIsTokenAlive';

function App() {

  const [loginParameters, setLoginParameters] = useState({
    roles: [],
    accesToken: '',
    userName: '',
    userSurname: '',
    language: '',
    isFirstLogin: 0,
    company: '',
    isNeeded2FA: 0,
    is2FAValidated: 0,
  });

  useEffect(() => {
    const storedUser = window.localStorage.getItem('loggedNewIntranetAppUser')
    if (!(typeof window === "undefined") && storedUser && storedUser !== '') {
      const user = JSON.parse(storedUser)
      checkIsTokenAlive(user.accesToken).then(response => {
        if (response !== 'Token exìred') {setLoginParameters(user)}
      })
  
    }
  }, [])

  if (!loginParameters.accesToken) return (
    <Login
      setLoginParameters={(e) => setLoginParameters({
        ...loginParameters,
        isNeeded2FA: e.isNeeded2FA,
        isFirstLogin: e.isFirstLogin,
        userName: e.userName,
        userSurname: e.userSurname,
        company: e.company,
        language: e.language,
        roles: e.roles,
        accesToken: e.accesToken
      })}
    />
  );
  else if (loginParameters.accesToken && loginParameters.isNeeded2FA && !loginParameters.is2FAValidated) {
    return (
      <TwoFactorAuth
        setLoginParameters={(e) => setLoginParameters({
          ...loginParameters,
          is2FAValidated: e.is2FAValidated,
        })}
        loginParameters={loginParameters}
      />
    );
  }
  else {
    return (
      <AuthenticatedUser
        loginParameters={loginParameters}
      />
    );
  }
}

export default App;
